import { render } from "./Vorstand.vue?vue&type=template&id=0a85f41a"
import script from "./Vorstand.vue?vue&type=script&lang=js"
export * from "./Vorstand.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__